import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=70f837fc"
import script from "./Tel.vue?vue&type=script&lang=js"
export * from "./Tel.vue?vue&type=script&lang=js"
import style0 from "./Tel.vue?vue&type=style&index=0&id=70f837fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports